import { useState } from 'react'

import UserAppContext from '../../hook/UserAppContext'
import Aside from '../../components/aside/Aside'
import Main from '../pages/Main'

import './content.css'

const Content = () => {

      const {user} = UserAppContext()
      const [current, setCurrent] = useState('home')

      if(user.length === 0) return 

      return (
            <div className="content">
                  <div className="content_bg">
                        <div className="content_bg__inner">
                              <div className="content_bg__layear"></div>
                        </div>
                  </div>
                  <div className="template">
                        <Aside isCurrent={current} isSetCurrent={setCurrent} />
                        <Main isCurrent={current} />
                  </div>
            </div>
      )
}

export default Content
